/**
 * Rating class 定義 (SPEC 43)。
 *
 * range は configuration として 1 箇所にまとめる。
 * 色は web 側の CSS 変数名に対応させ、ここでは意味名だけを持つ。
 */
/**
 * レーティング計算の共通パラメータ。
 *
 * アルゴリズム本体は packages/rating にあるが、
 * 「初期値はいくつか」「1 回で最大どれだけ動くか」は利用者へ説明する値でもある。
 * 実装と説明がずれないよう、両方がここを参照する。
 */
export const RATING_CONFIG = {
    /** 未 rated の参加者に与える初期レート。 */
    INITIAL_RATING: 1200,
    /** 1 回のコンテストでの変動幅の上限。異常データで吹き飛ばないための安全弁。 */
    MAX_DELTA_PER_CONTEST: 700,
};
/** 降順（高い順）に並べる。lookup はこの順で最初に一致したものを返す。 */
export const RATING_CLASSES = [
    { slug: 'grandmaster', name: 'Grandmaster', minRating: 2800 },
    { slug: 'master', name: 'Master', minRating: 2400 },
    { slug: 'diamond', name: 'Diamond', minRating: 2000 },
    { slug: 'platinum', name: 'Platinum', minRating: 1600 },
    { slug: 'gold', name: 'Gold', minRating: 1200 },
    { slug: 'silver', name: 'Silver', minRating: 800 },
    { slug: 'bronze', name: 'Bronze', minRating: 400 },
    { slug: 'beginner', name: 'Beginner', minRating: 1 },
    { slug: 'newbie', name: 'Newbie', minRating: Number.NEGATIVE_INFINITY },
];
const UNRATED = { slug: 'unrated', name: 'Unrated', minRating: Number.NaN };
/**
 * rating が null（未参加）の場合は Unrated を返す。
 * 0 と未参加を区別するため、null チェックを呼び出し側任せにしない。
 */
export function getRatingClass(rating) {
    if (rating === null || rating === undefined || Number.isNaN(rating)) {
        return UNRATED;
    }
    for (const cls of RATING_CLASSES) {
        if (rating >= cls.minRating) {
            return cls;
        }
    }
    // RATING_CLASSES の末尾は -Infinity なので理論上到達しないが、
    // 配列を編集したときに静かに壊れないよう明示的に落とす。
    return UNRATED;
}
//# sourceMappingURL=rating-classes.js.map